import styled from 'styled-components';

const SelectInputWrapper = styled.div`
  .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
  .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
    padding-right: 12px;
  }
  .ant-select-arrow {
    right: 7px;
  }
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0;
  }
`;

export default SelectInputWrapper;
